import { VpbButton } from './src/button.js';
customElements.get('vpb-button') || customElements.define('vpb-button', VpbButton);
//# sourceMappingURL=register.js.map